import { reactive, computed } from '@vue/composition-api'
import { dataErrorMessage } from '@/util/common'
import * as _ from 'lodash'

export const ContractAccount = (context) => {
  const store = context.root.$store
  const { contract, users } = store.state


  const promiseList = [
    store.dispatch('contract/getContractData'),
    store.dispatch('users/getUsersData'),
    store.dispatch('contractPack/getPackageData')
  ]

  Promise
    .all(promiseList)
    .then(() => {
      state.initialize = true
    })
  
  

  const filterdUser = computed(() => {
    return _.filter(users.users, user => {
      return !state.searchKeywordCommit || user.name.replace(/[\s　]/g, '').indexOf(state.searchKeywordCommit) > -1
    })
  })

  const state = reactive({
    initialize: false,
    visibleViewLicense: false,
    visibleReset: false,
    visibleDetail: false,
    visibleCreate: false,
    visibleEdit: false,
    visibleAdminTransfer: false,
    visibleContractAccountStop: false,
    noteIsMax: computed(() => contract.note_number >= contract.note_number_max),
    accountIsMax: computed(() => contract.account_number >= contract.account_number_max),
    searchKeyword: '',
    searchKeywordCommit: ''
  })

  const action = reactive({
    currentUser: computed(() => store.getters['users/getCurrentUser']),
    start: (id) => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/setCurrentUser', id)
        .then(async() => {
          await store
            .dispatch('users/startUser')
            .then(data => {
              if (data.status === 0) store.dispatch('common/showToast', { text: `${action.currentUser.name}のアカウントを有効にしました。` })
              else dataErrorMessage(data)
            })
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    stop: (id) => {
      store
        .dispatch('users/setCurrentUser', id)
        .then(() => {
          state.visibleContractAccountStop = true
        })
    },
    stopClose: () => {
      state.visibleContractAccountStop = false
    },
    stopSubmit: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/stopUser')
        .then(data => {
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: `${action.currentUser.name}のアカウントを停止しました。` })
            action.stopClose()
          } else {
            dataErrorMessage(data)
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    reset: (id) => {
      store
        .dispatch('users/setCurrentUser', id)
        .then(() => {
          state.visibleReset = true
        })
    },
    resetClose: () => {
      state.visibleReset = false
    },
    resetSubmit: () => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/resetUser')
        .then(data => {
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: `${action.currentUser.name}のアカウントをリセットしました。` })
            action.resetClose()
          } else {
            dataErrorMessage(data)
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    viewLicense: (id) => {
      store
        .dispatch('users/setCurrentUser', id)
        .then(() => {
          state.visibleViewLicense = true
        })
      
    },
    viewDetail: (id) => {
      store
        .dispatch('users/setCurrentUser', id)
        .then(() => {
          state.visibleDetail = true
        })
    },
    editSubmit: (changeUser) => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/updateUser', changeUser)
        .then(async (data) => {
          await store.dispatch('users/getUsersData')
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: '利用者情報を更新しました。' })
            state.visibleEdit = false
          } else {
            dataErrorMessage(data)
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    adminSubmit: (users) => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/bulkUpdateUser', users)
        .then(async (data) => {
          await store.dispatch('users/getUsersData')
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: '利用者情報を更新しました。' })
            state.visibleAdminTransfer = false
          } else {
            dataErrorMessage(data)
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    createSubmit: (user) => {
      store.dispatch('common/showLoading')
      store
        .dispatch('users/addUser', user)
        .then(async (data) => {
          await store.dispatch('users/getUsersData')
          await store.dispatch('contract/getContractData')
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: 'アカウントを追加しました。' })
            state.visibleCreate = false
          } else {
            dataErrorMessage(data)
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    },
    search: () => {
      state.searchKeywordCommit = state.searchKeyword.replace(/[\s　]/g, '')
    }
  })

  return {
    state,
    filterdUser,
    contract,
    action,
    users
  }
}
